<template>
  <div>
    <mdb-btn color="default" outline="success" size="sm" @click.native="loginState=true">Login<mdb-icon icon="sign-in-alt" class="ml-1"/></mdb-btn>
    <mdb-modal :show="loginState" @close="loginState = false">
      <mdb-modal-header class="text-center">
        <mdb-modal-title tag="h4" bold class="w-100">Sign in</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body class="mx-3 grey-text">
        <mdb-input label="Your email" icon="envelope" type="email" class="mb-5" v-model="email"/>
        <mdb-input label="Your password" icon="lock" type="password" v-model="password"/>
      </mdb-modal-body>
      <mdb-modal-footer center>
        <mdb-btn @click.native="loginState = false" @click="login()">Login</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import mdbBtn from 'mdbvue/lib/components/mdbBtn'
import mdbIcon from 'mdbvue/lib/components/mdbIcon'
import mdbModal from 'mdbvue/lib/components/mdbModal'
import mdbModalHeader from 'mdbvue/lib/components/mdbModalHeader'
import mdbModalBody from 'mdbvue/lib/components/mdbModalBody'
import mdbModalFooter from 'mdbvue/lib/components/mdbModalFooter'
import mdbInput from 'mdbvue/lib/components/mdbInput'
import mdbModalTitle from 'mdbvue/lib/components/mdbModalTitle'

export default {
  components: {
    mdbBtn,
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbModalFooter,
    mdbInput,
    mdbModalTitle,
    mdbIcon
  },
  data () {
    return {
      loginState: false,
      email: '',
      password: ''
    }
  },
  methods: {
    login () {
      firebase.auth().signInWithEmailAndPassword(this.email, this.password).then((user) => {
        this.$router.replace('/admin')
      }).catch((err) => {
        alert(err.message)
      })
    }
  }
}
</script>
